import { Swiper, Navigation, EffectFade } from 'swiper/swiper.esm';

export default function() {
  Swiper.use([Navigation, EffectFade]);

  // eslint-disable-next-line no-new
  new Swiper('.swiper-products', {
    speed: 500,
    slidesPerView: 1.35,
    spaceBetween: 20,
    initialSlide: 0,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.35,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 15,
      },
    },
  });
  // eslint-disable-next-line no-new
  new Swiper('.swiper-collections', {
    speed: 500,
    slidesPerView: 1.35,
    spaceBetween: 20,
    initialSlide: 0,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.35,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 7,
      },
    },
  });
}
